<template>
  <div class="o-confirm-forgot-password">
    <MoleculeConfirmForgotPassword/>
  </div>
</template>

<script>
export default {
  name: 'OrganismConfirmForgotPassword',

  components: {
    MoleculeConfirmForgotPassword: () => import('@/components/molecules/MoleculeConfirmForgotPassword')
  }
}
</script>
